import { BASE_URL } from '../constants';

export function imageAsset(path: string): string {
  return `${BASE_URL}/images/${path}`;
}

export const MAIN_BACKGROUND_IMAGE = imageAsset('admin/background.png');
